import { IconCheck, IconCopy } from "@tabler/icons-react";
import { useState } from "react";
import { Badge, Paper, Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui";
import { PASSWORD_DEMO, USUARIOS_DEMO } from "../data/marketing-content";

/**
 * Card "Usuarios de demo" · listado de credenciales pre-seed con un botón
 * para copiar la contraseña compartida `Demo!2025`. En producción este
 * bloque se quita por env-flag.
 */
export function UsuariosDemoCard() {
  const [copiado, setCopiado] = useState(false);

  async function copiar() {
    await navigator.clipboard.writeText(PASSWORD_DEMO);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 1500);
  }

  return (
    <Paper padding="md" className="bg-muted">
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <p className="text-xs font-semibold uppercase text-muted-foreground">Acceso rápido</p>
          <Tooltip>
            <TooltipTrigger asChild>
              <button type="button" onClick={() => void copiar()} className="flex items-center gap-1 text-[11px] font-medium text-multiva-700">
                {copiado ? <IconCheck size={12} /> : <IconCopy size={12} />}
                {PASSWORD_DEMO}
              </button>
            </TooltipTrigger>
            <TooltipContent side="left">{copiado ? "Copiado" : "Copiar contraseña"}</TooltipContent>
          </Tooltip>
        </div>
        <div className="flex flex-col gap-1">
          {USUARIOS_DEMO.map((u) => (
            <div key={u.email} className="flex items-center justify-between gap-2">
              <code className="text-[11px] text-foreground">{u.email}</code>
              <Badge size="xs" variant="light" color="multiva" className="shrink-0">
                {u.rol}
              </Badge>
            </div>
          ))}
        </div>
      </div>
    </Paper>
  );
}
